import SwipeController from './SwipeController';

export default SwipeController;
